import React from 'react';
import PropTypes from 'prop-types';
import { WysiwygField as DefaultWysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';
import { replaceTooltip, replaceMediaToDownloadLinks } from '../../helpers/wysiwyg';

const WysiwygField = ({
  html,
  ...props
}) => {
  let newHtml = replaceTooltip(html);
  newHtml = replaceMediaToDownloadLinks(newHtml);


  return (
    <DefaultWysiwygField
      html={newHtml}
      {...props}
    />
  );
};
PropTypes.propTypes = {
  html: PropTypes.string.isRequired,
};

export default WysiwygField;
